"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateMenuOrderItemsResultErrorToJSON = exports.ValidateMenuOrderItemsResultErrorFromJSONTyped = exports.ValidateMenuOrderItemsResultErrorFromJSON = void 0;
var runtime_1 = require("../runtime");
function ValidateMenuOrderItemsResultErrorFromJSON(json) {
    return ValidateMenuOrderItemsResultErrorFromJSONTyped(json, false);
}
exports.ValidateMenuOrderItemsResultErrorFromJSON = ValidateMenuOrderItemsResultErrorFromJSON;
function ValidateMenuOrderItemsResultErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorMessage': json['errorMessage'],
        'externalId': !(0, runtime_1.exists)(json, 'externalId') ? undefined : json['externalId'],
        'menuItemId': !(0, runtime_1.exists)(json, 'menuItemId') ? undefined : json['menuItemId'],
    };
}
exports.ValidateMenuOrderItemsResultErrorFromJSONTyped = ValidateMenuOrderItemsResultErrorFromJSONTyped;
function ValidateMenuOrderItemsResultErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorMessage': value.errorMessage,
        'externalId': value.externalId,
        'menuItemId': value.menuItemId,
    };
}
exports.ValidateMenuOrderItemsResultErrorToJSON = ValidateMenuOrderItemsResultErrorToJSON;
